/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pitch_Word_BodyInputs */



/**
* | output |
* | --- |
* | "The manuscript comes back with tracked changes and comments in Word. It is processed and stored in the Nordics and is not used to train AI." |
*
* @param {Pitch_Word_BodyInputs} inputs
* @param {{ locale?: "nb-NO" | "en-GB" | "sv-SE" }} options
* @returns {LocalizedString}
*/
export const pitch_word_body = /** @type {((inputs?: Pitch_Word_BodyInputs, options?: { locale?: "nb-NO" | "en-GB" | "sv-SE" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pitch_Word_BodyInputs, { locale?: "nb-NO" | "en-GB" | "sv-SE" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en-GB") return /** @type {LocalizedString} */ ("The manuscript comes back with tracked changes and comments in Word. It is processed and stored in the Nordics and is not used to train AI.")
	if (locale === "sv-SE") return /** @type {LocalizedString} */ ("Manuset kommer tillbaka med spårade ändringar och kommentarer i Word. Det behandlas och lagras i Norden och används inte för att träna AI.")
	return /** @type {LocalizedString} */ ("Manuset kommer tilbake med sporede endringer og kommentarer i Word. Det behandles og lagres i Norden og brukes ikke til å trene kunstig intelligens.")
});